import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Dropdown, Menu, Space, Modal } from "antd";
import { HomeOutlined, UserOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { useAppSelector } from "engine/store";
import logo from "assets/images/logo.png";
import { StyledHeader } from "./styled";

export const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.auth.user);

  const handleLogout = () => {
    Modal.confirm({
      title: "Confirm Logout",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you want to logout?",
      okText: "Logout",
      cancelText: "Cancel",
      onOk: () => {
        localStorage.removeItem("admin_token");
        navigate("/login");
      },
    });
  };

  return (
    <StyledHeader>
      <div className="logo">
        <Link to="/dashboard/articles">
          <img src={logo} alt="ReMinfo" />
        </Link>
      </div>
      <Space>
        <Link to="/">
          <Button 
            type="link" 
            icon={<HomeOutlined />}
            style={{ color: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            Go to directory
          </Button>
        </Link>
        {user && (
          <Dropdown
            overlay={
              <Menu
                items={[
                  {
                    key: "1",
                    label: (
                      <Button onClick={handleLogout} type="text">
                        {t("dashboard.logout")}
                      </Button>
                    ),
                  },
                ]}
              />
            }
            placement="bottomRight"
            arrow
          >
            <Button icon={<UserOutlined />}>
              {user.firstname} {user.lastname}
            </Button>
          </Dropdown>
        )}
      </Space>
    </StyledHeader>
  );
};
